import type { PropRule } from './analytics-types.js';

export function locationSearchEventProps<const Common extends Record<string, PropRule>>(common: Common) {
  const reason = new Set(['denied', 'unavailable', 'timeout', 'dismissed', 'unsupported', 'unknown']);
  return {
    locate_search_recovery_shown: { ...common, reason },
    locate_search_recovery_clicked: { ...common, reason },
    locate_search_recovered: { ...common, reason },
    locate_search_task_continued: { ...common, reason, action: new Set(['draw', 'region', 'save', 'share', 'export']) },
  };
}
